import * as React from 'react';
import { FC } from 'react';

import { DeliveryRoutes } from '../routes/delivery-routes';
import { GeolocationRoutes } from '../routes/geolocation-routes';
import { PickUpRoutes } from '../routes/pickup-routes';
import { StoreInfoRoutes } from '../routes/store-info-routes';

interface IStoreLocatorRoutesProps {
  dismissAddressModalUrl: string;
  redirectUrl: string;
  /**
   * This disables the modal route when selecting Delivery option in store locator.
   * The Delivery page will be rendered in the same page as Pickup
   */
  deliveryNoModal?: boolean;
}

/**
 *
 * StoreLocatorRoutes contains all internal route logic for the store locator
 *  handles rendering service mode-specific modals, error messages, and store info
 *
 */
export const StoreLocatorRoutes: FC<IStoreLocatorRoutesProps> = ({
  dismissAddressModalUrl,
  redirectUrl,
  deliveryNoModal,
}) => {
  return (
    <>
      <PickUpRoutes redirectUrl={redirectUrl} />

      <DeliveryRoutes
        dismissAddressModalUrl={dismissAddressModalUrl}
        redirectUrl={redirectUrl}
        deliveryNoModal={deliveryNoModal}
      />

      <GeolocationRoutes />

      <StoreInfoRoutes />
    </>
  );
};
